export abstract class QuoteToggleConstants {
    static DELAYED_QUOTE = 'D';
    static REALTIME_QUOTE = 'R';
    static TOGGLE_ACTION = 'toggle';
    static REFRESH_ACTION = 'refresh';
    static TOGGLE_ON_AGREE = 'toggleOnAgree';
    static TIME_ZONE: string = 'America/New_York';
    static DATE_FORMAT: string = 'MM/DD/YYYY';
    static SHORTTIME_FORMAT: string = 'LT';
}
